import React from 'react'
import PageContainer from '../../layout/PageContainer';
import CorredorCreditoPolicyList from './CorredorCreditoPolicyList';


const CorredorCreditoPolicyListContainer = () => (
  <PageContainer
    breadcrumbs={[
      { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
      { id: 1, name: 'CORREDOR', url: '/corredor/polizas-credito' },
      { id: 2, name: 'PÓLIZAS CRÉDITO'},
    ]}
    clientFilter={{
      type: 'corredor',
      ramo: 'credito',
      showFilter: true,
    }}
  >
    {(corredor) => (
      <CorredorCreditoPolicyList corredor={corredor} />
    )}
  </PageContainer>
);

export default CorredorCreditoPolicyListContainer;
